import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=6aec42a2&scoped=true"
import script from "./msg.vue?vue&type=script&lang=js"
export * from "./msg.vue?vue&type=script&lang=js"
import style0 from "./msg.vue?vue&type=style&index=0&id=6aec42a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec42a2",
  null
  
)

export default component.exports